module.exports = __webpack_public_path__ + "static/media/Indian-Flag.90920b62.svg";